import React from "react";
import "./CertificationCarousel.css";
import { Fade } from "react-reveal";

const CertificationCarousel = ({ certifications, theme }) => {
  if (certifications.length === 0) return null;

  return (
    <div className="modern-certifications-container">
      {/* Certifications Grid */}
      <div className="certifications-grid">
        {certifications.map((cert, index) => (
          <Fade up duration={1000} delay={index * 200} key={index}>
            <a
              href={cert.certificate_link}
              target="_blank"
              rel="noopener noreferrer"
              className="modern-cert-card cert-card-link"
            >
              <div className="cert-card-content">
                <h3 className="modern-cert-title" style={{ color: theme.text }}>
                  {cert.title}
                </h3>
                <p
                  className="modern-cert-subtitle"
                  style={{ color: theme.secondaryText }}
                >
                  {cert.subtitle}
                </p>

                <div className="cert-card-footer">
                  <div className="cert-issuer">
                    <span className="cert-issuer-label">Issued by:</span>
                    <span
                      className="cert-issuer-name"
                      style={{ color: theme.imageHighlight }}
                    >
                      {cert.alt_name}
                    </span>
                  </div>
                  <div
                    className="cert-view-indicator"
                    style={{ color: theme.imageHighlight }}
                  >
                    View Certificate →
                  </div>
                </div>
              </div>

              {/* Hover Image Overlay */}
              <div className="cert-hover-image">
                <img
                  className="cert-full-image"
                  src={require(`../../assests/images/${cert.logo_path}`)}
                  alt={cert.alt_name}
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />
              </div>

              <div
                className="cert-card-glow"
                style={{ background: cert.color_code }}
              ></div>
            </a>
          </Fade>
        ))}
      </div>
    </div>
  );
};

export default CertificationCarousel;
